/**
 * an enum describing possible values for `GraphQLDeprecationLog.requestType`
 */
export enum GraphQLDeprecationLogRequestType {
  /**
   * the request was a query
   */
  Query = 'Query',
  /**
   * the request was a mutation
   */
  Mutation = 'Mutation',
  /**
   * the request was a field or field resolver
   */
  Field = 'Field',
}
